"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Wrapper function around the window.setTimeout that returns a function to dispose the setTimeout.
 * This function can be used in combination with the DisposableManager
 *
 * @param handler
 * @param timeout
 * @param args
 */
function setTimeout(handler, timeout) {
  var _window;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var t = (_window = window).setTimeout.apply(_window, [handler, timeout].concat(args));

  return function () {
    return window.clearTimeout(t);
  };
}

var _default = setTimeout;
exports.default = _default;